import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { styledWithTheme } from "../../context";
import { filterProps } from "../../utils";
import { DateMarkerType } from "../interfaces";
import { DATE_MARKER_SIZE, DATE_MARKER_COLOR } from "./constants";
import { jsx as ___EmotionJSX } from "@emotion/core";
var commonStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: DATE_MARKER_SIZE,
  height: DATE_MARKER_SIZE
};

var getBorderStyle = function getBorderStyle(theme, isInverted) {
  return "2px solid ".concat(theme.selectors.color(isInverted ? 'neutral0' : DATE_MARKER_COLOR));
};

var SquareOutline = styledWithTheme('div', {
  shouldForwardProp: filterProps(['isInverted', 'size'])
})(function (_ref) {
  var theme = _ref.theme,
      isInverted = _ref.isInverted,
      size = _ref.size;
  var borderStyle = getBorderStyle(theme, isInverted);
  return _objectSpread(_objectSpread({}, commonStyles), {}, {
    width: size,
    height: size,
    borderLeft: borderStyle,
    borderBottom: borderStyle
  });
});
SquareOutline.displayName = 'SquareOutline';
var RoundOutline = styledWithTheme('div', {
  shouldForwardProp: filterProps(['isInverted', 'size'])
})(function (_ref2) {
  var theme = _ref2.theme,
      isInverted = _ref2.isInverted,
      size = _ref2.size;
  var borderStyle = getBorderStyle(theme, isInverted);
  return _objectSpread(_objectSpread({}, commonStyles), {}, {
    width: size,
    height: size,
    border: borderStyle,
    borderTop: '2px solid transparent',
    borderRadius: 16,
    // Rotate so that the border is in the correct orientation, with
    // the gap in the top right
    transform: 'rotate(45deg)',
    // Rotate the inner elements back the other way. Using `> *`
    // only selects direct children, and will select them no
    // matter what element type they are
    '> *': {
      transform: 'rotate(-45deg)'
    }
  });
});
SquareOutline.displayName = 'SquareOutline';

var OutlineDateMarker = function OutlineDateMarker(_ref3) {
  var children = _ref3.children,
      type = _ref3.type,
      isInverted = _ref3.isInverted,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? DATE_MARKER_SIZE : _ref3$size;

  if (type === DateMarkerType.SquareOutline) {
    return ___EmotionJSX(SquareOutline, {
      isInverted: isInverted,
      size: size
    }, children);
  }

  if (type === DateMarkerType.RoundOutline) {
    return ___EmotionJSX(RoundOutline, {
      isInverted: isInverted,
      size: size
    }, children);
  } // Otherwise don't add anything to the DOM


  return ___EmotionJSX(React.Fragment, null, children);
};

OutlineDateMarker.displayName = 'OutlineDateMarker';
export default OutlineDateMarker;